"use client";

import { useEffect, useState } from "react";
import { safeGet, safeSet } from "@/components/onboarding/safe-storage";
import type { LeagueId } from "@/lib/odds-screen/live/types";

export function rememberedLeaguesKey(surface: string): string {
  return `upsider_live_leagues:${surface}`;
}

function readRemembered(surface: string): readonly LeagueId[] {
  try {
    const parsed: unknown = JSON.parse(safeGet(rememberedLeaguesKey(surface)) ?? "[]");
    return Array.isArray(parsed) && parsed.every((id) => typeof id === "string") ? parsed : [];
  } catch {
    return [];
  }
}

export function useRememberedLeagues(surface: string, latest: readonly LeagueId[] | null): readonly LeagueId[] {
  const [remembered] = useState(() => readRemembered(surface));
  const json = latest === null ? null : JSON.stringify(latest);
  useEffect(() => {
    if (json !== null) safeSet(rememberedLeaguesKey(surface), json);
  }, [surface, json]);
  return remembered;
}
